import api from './index'
import { axios } from '@/utils/request'

export function createPratice(parameter) {
  return axios({
    url: api.BaseURL + api.Pratice + 'create',
    method: 'POST',
    data: parameter
  })
}

export function getListPratice(parameter) {
  return axios({
    url: api.BaseURL + api.Pratice + 'list',
    method: 'GET',
    params: parameter
  })
}

export function updatePratice(parameter) {
  return axios({
    url: api.BaseURL + api.Pratice + 'update',
    method: 'POST',
    data: parameter
  })
}

export function deletePratice(parameter) {
  return axios({
    url: api.BaseURL + api.Pratice + 'delete',
    method: 'POST',
    data: parameter
  })
}

export function createQuestion(parameter) {
  return axios({
    url: api.BaseURL + api.Pratice + 'create_question',
    method: 'POST',
    data: parameter
  })
}

export function getListQuestion(parameter) {
  return axios({
    url: api.BaseURL + api.Pratice + 'list_question',
    method: 'GET',
    params: parameter
  })
}

export function getDetailQuestion(parameter) {
  return axios({
    url: api.BaseURL + api.Pratice + 'detail_question',
    method: 'GET',
    params: parameter
  })
}

export function updateQuestion(parameter) {
  return axios({
    url: api.BaseURL + api.Pratice + 'update_question',
    method: 'POST',
    data: parameter
  })
}

export function deleteQuestion(parameter) {
  return axios({
    url: api.BaseURL + api.Pratice + 'delete_question',
    method: 'POST',
    data: parameter
  })
}